const config = {
  namespaced: true,
  state: {
    isSlidbarOpen: true
  },

  mutations: {
    SET_SLIDBAR_OPEN: (state, isSlidbarOpen) => {
      state.isSlidbarOpen = isSlidbarOpen;
    }
  },
  actions: {}
};
export default config;
